module.exports = __webpack_public_path__ + "img/banner.e839fae.png";